var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"showDesc":false,"showName":false,"hiddenKeys":['updated_at'],"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }